export const Env = {
  dev: 'dev',
  stage: 'stage',
  prod: 'prod',
} as const;

export type Env = (typeof Env)[keyof typeof Env];
